import { useState } from "react";
import { useLogStatsMutation } from "../../slices/coach/coachSlice";
import { Form, Button } from "react-bootstrap";
import Loader from "../Loader";

const toDatetimeLocal = (date = new Date()) => {
    return new Date(date - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16);
};

const StatsLog = (({ setShowStatsLog }) => {
    const [weight, setWeight] = useState('');
    const [sysbp, setSysbp] = useState('');
    const [diasbp, setDiasbp] = useState('');
    const [heartRate, setHeartRate] = useState('');
    const [date, setDate] = useState(toDatetimeLocal());

    const [logStats, { isLoading }] = useLogStatsMutation();

    const submitHandler = async (e) => {
        e.preventDefault();

        try {
            await logStats({
                weight,
                sysbp,
                diasbp,
                heart_rate: heartRate,
                record_date: date,
            }).unwrap();
            window.alert("Stats logged successfully!");
        } catch (error) {
            window.alert("Something went wrong");
            console.error(error?.data?.message || error.error);
        }

        setShowStatsLog(false);
    }

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <h2 className='mt-3'>Log Stats</h2>

                <Form onSubmit={submitHandler}>
                    <Form.Group controlId='weight' className='my-1' style={{ maxWidth: '250px' }}>
                        <Form.Label>Weight (lbs)</Form.Label>
                        <Form.Control 
                            type='number'
                            placeholder='Enter weight'
                            value={weight}
                            onChange={(e) => setWeight(e.target.value)}>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId='sysbp' className='my-1' style={{ maxWidth: '250px' }}>
                        <Form.Label>Systolic BP (the big number)</Form.Label>
                        <Form.Control 
                            type='number'
                            placeholder='Enter systolic bp'
                            value={sysbp}
                            onChange={(e) => setSysbp(e.target.value)}>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId='diasbp' className='my-1' style={{ maxWidth: '250px' }}>
                        <Form.Label>Diastolic BP (the little number)</Form.Label>
                        <Form.Control 
                            type='number'
                            placeholder='Enter diastolic bp'
                            value={diasbp}
                            onChange={(e) => setDiasbp(e.target.value)}>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId='heartrate' className='my-1' style={{ maxWidth: '250px' }}>
                        <Form.Label>Heart Rate (bpm)</Form.Label>
                        <Form.Control 
                            type='number'
                            placeholder='Enter heart rate'
                            value={heartRate}
                            onChange={(e) => setHeartRate(e.target.value)}>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId='date-time' className='my-1' style={{ maxWidth: '250px' }}>
                        <Form.Label>Date-Time</Form.Label>
                        <Form.Control 
                            type='datetime-local'
                            value={date}
                            onChange={(e) => setDate(e.target.value)}>
                        </Form.Control>
                    </Form.Group>

                    <Button type='submit' className='quiz-btn-dark mt-2' disabled={isLoading}>
                        Log Stats
                    </Button>
                    <Button onClick={() => setShowStatsLog(false)} className='quiz-btn-dark mt-2' disabled={isLoading}>
                        Cancel
                    </Button>
                    { isLoading && <Loader />}
                </Form>
            </div>
        </div>
    )
});

export default StatsLog